import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators';
import { BillMergeDataset } from './bill.merge.dataset';
import { InvoiceMergeDataset } from './invoice.merge.dataset';

@MergeDataset({
    entity: ActivityEntityName.CreditNoteSupplier,
    dependsOn: [
        ActivityEntityName.Job,
        ActivityEntityName.WorkOrder,
    ]
})
export class CreditNoteSupplierMergeDataset extends BillMergeDataset {
}


